export default (value: any, length: number): any[] => {
  return Array.from({ length }).fill(value)
}
